module.exports = __webpack_public_path__ + "static/media/icon-card-inactive@2x.406ebf51.png";